const logger = {
  debug: (...args: any[]) => {
    // eslint-disable-next-line no-console
    console.debug(...args);
  },
};

export default logger;
